import React from 'react';

import {Controller, useForm} from 'react-hook-form';
import {Button, Grid, TextField} from '@material-ui/core';
import Icon from '@mdi/react';
import {mdiKeyOutline, mdiVectorPolylineEdit} from '@mdi/js';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import {WarehouseFilters} from '../interfaces';

// styles
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontWeight: 500,
      width: '100%',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '8px',
      marginTop: '21px',
    },
    inputHolder: {
      flex: 1,
    },
  })
);

type Props = {
  submitFilters: (values: WarehouseFilters) => void;
  clearForm: () => void;
};

const WarehouseFilter = ({submitFilters, clearForm}: Props) => {
  const classes = useStyles();
  const {handleSubmit, control, reset} = useForm<WarehouseFilters>();

  const submitForm = (values: WarehouseFilters) => {
    submitFilters(values);
  };

  const handleResetForm = () => {
    reset({
      'zoneName.equals': '',
      'aisleCode.equals': '',
      'columnCode.equals': '',
      'rowCode.equals': '',
      'unitBarcode.equals': '',
      'unitCode.equals': '',
    });
    clearForm();
  };

  return (
    <form onSubmit={handleSubmit(submitForm)}>
      <Grid container spacing={1}>
        <Grid container item xs={12} md={6} lg={3} alignItems="center">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiVectorPolylineEdit} size={1} />
            </span>

            <div style={{width: '100%'}}>
              <Controller
                name="zoneName.equals"
                label="نام زون"
                control={control}
                as={<TextField type="text" fullWidth />}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={12} md={6} lg={3} alignItems="center">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiKeyOutline} size={1} />
            </span>

            <div style={{width: '100%'}}>
              <Controller
                name="aisleCode.equals"
                label="شماره راهرو"
                control={control}
                as={<TextField type="text" fullWidth />}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={12} md={6} lg={3} alignItems="center">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiKeyOutline} size={1} />
            </span>

            <div style={{width: '100%'}}>
              <Controller
                name="columnCode.equals"
                label="شماره ستون"
                control={control}
                as={<TextField type="text" fullWidth />}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={12} md={6} lg={3} alignItems="center">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiKeyOutline} size={1} />
            </span>

            <div style={{width: '100%'}}>
              <Controller
                name="rowCode.equals"
                label="شماره طبقه"
                control={control}
                as={<TextField type="text" fullWidth />}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={12} md={6} lg={3} alignItems="center">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiKeyOutline} size={1} />
            </span>

            <div style={{width: '100%'}}>
              <Controller
                name="unitBarcode.equals"
                label="سریال یونیت"
                control={control}
                as={<TextField type="text" fullWidth />}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={12} md={6} lg={3} alignItems="center">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiKeyOutline} size={1} />
            </span>

            <div style={{width: '100%'}}>
              <Controller
                name="unitCode.equals"
                label="شماره یونیت"
                control={control}
                as={<TextField type="text" fullWidth />}
              />
            </div>
          </div>
        </Grid>
        <Grid
          container
          item
          xs={12}
          alignItems="center"
          style={{marginTop: '1rem'}}
          justify="flex-end"
        >
          <Grid item xs={2} style={{marginLeft: '1rem'}}>
            <Button
              style={{width: '100%'}}
              variant="contained"
              color="default"
              onClick={handleResetForm}
            >
              پاک کردن فرم
            </Button>
          </Grid>
          <Grid item xs={3}>
            <Button
              type="submit"
              style={{width: '100%'}}
              variant="contained"
              color="secondary"
            >
              جستجو
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
};

export default WarehouseFilter;
